import axiosInstance from "@/services/axiosInterceptor";

export async function getUserAvailability(day) {
  try {
    const response = await axiosInstance.get(`users/availability?day=${day}`);
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
}
export async function getUserUnavailability(date) {
  try {
    const response = await axiosInstance.get(
      date ? `users/unavailability?date=${date}` : `users/unavailability`
    );
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
}
